
const digest = '2c941952ef1cd0bb1e23778aca2d18333f9fbe80516883c53e8e6b56020bb82c';
const classes = {"tabControlWrapper":"_tabControlWrapper_39ag5_1","primaryControls":"_primaryControls_39ag5_7","tabButton":"_tabButton_39ag5_16","tabButtonActive":"_tabButtonActive_39ag5_26","tab":"_tab_39ag5_1"};
const css = `._tabControlWrapper_39ag5_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  width: 100%;
}
._tabControlWrapper_39ag5_1 ._primaryControls_39ag5_7 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: -1px;
  z-index: 1;
  justify-content: center;
}
._tabControlWrapper_39ag5_1 ._tabButton_39ag5_16 {
  font-size: 16px;
  color: #3e3f42;
  background-color: #f2f4f7;
  border: 1px solid #eaedf3;
  padding: 16px 23px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
}
._tabControlWrapper_39ag5_1 ._tabButtonActive_39ag5_26 {
  background-color: #ffffff;
  border-bottom-color: #ffffff;
  color: #619612;
  font-weight: 500;
}

._tab_39ag5_1 {
  width: 100%;
  border: 1px solid #eaedf3;
  padding: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  